export default __webpack_public_path__ + "static/media/5.1e101c29.jpg";